import classes from "./Boss.module.css";
import profile1 from "../assets/img/profile1.png";
import React from "react";
import TypeAnimation from "react-type-animation";

const Boss = () => {
  return (
    <div className="home">
      <div className={classes.boss}>
        <div className={classes.intro}>
          <h1>Welcome</h1>
          <h2>
            I am
            <TypeAnimation
              cursor={true}
              sequence={[
                " Abhishek Chamoli,",
                4000,
                " A Full Stack Web Application Developer,",
                4000,
                Infinity,
              ]}
              repeat={(3, Infinity)}
              wrapper="span"
            />
          </h2>

          <p>
            I am a Full Stack Web Application Developer With The Knowlege of
            Modern Web Development Technologies. Having a Great Knowlege of
            Programming. Offering Mastered HTML5, CSS3, Javascript, React Js,
            Express Js, Node Js, MongoDb, MYSQL & much more...
          </p>
          <a
            href="https://www.linkedin.com/in/abhishek-chamoli/"
            target="_blank"
          >
            Hire Me..
          </a>
        </div>
        <div className={classes.image}>
          <img src={profile1} alt="Abhishek Chamoli Software Developer" />
        </div>
      </div>
    </div>
  );
};

export default Boss;
